import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent {

  @Input("code") code!: string;
  @Input("title") title!: string;
  @Input("subtitle") subtitle!: string;
  @Input("image") image!: string;

  fillColor: string = '#0f395c';

  constructor() {}

  ngOnInit() {
    this.fillColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primario').trim();
  }

}
